import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import BadgeForTable from "components/shared-components/BadgeForTable";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import CustomSelectFilter from "components/shared-components/RemoteTable/custom-select-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import { useCheckRole, useListUserProfile, useMyHubsList } from "hooks";
import {
  useListPhaseOrderScan,
  useListPhaseOrderScanActionType,
  useListPhaseOrderScanStatus,
} from "hooks/order-scan/useOrderScan";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { setListBusColumn } from "store/actions";
import { getInitOrderScanParams, statusOption } from "./utils";
import { filteredObject, modifiedDateTime } from "helpers/utils";

const PhaseScanTheRow = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation(["bus"]);
  const inputSearchTrackingKey = useRef(null);
  const [allowFocusInputTrackingKey, setAllowFocusInputTrackingKey] =
    useState(true);
  const { isHubAdmin } = useCheckRole();

  /* ================================== START INIT STATE ==================================== */
  const [columnsTable, setColumnsTable] = useState([]);
  const [phaseOrderScanParams, setPhaseOrderScanParams] = useState(
    getInitOrderScanParams
  );

  /* =================================== END INIT STATE ===================================== */

  /* ===================================== START HOOKS ====================================== */

  // BUS LIST

  const onSuccessList = () => {
    setAllowFocusInputTrackingKey(true);
  };

  const onErrorList = () => {
    setAllowFocusInputTrackingKey(true);
  };

  const {
    isLoading,
    isFetching,
    data: listPhaseOrderScan,
    refetch: refetchListPhaseOrderScan,
  } = useListPhaseOrderScan(
    { params: phaseOrderScanParams },
    onSuccessList,
    onErrorList
  );

  const {
    refetch: fetchListPhaseOrderScanStatus,
    data: listPhaseOrderScanStatus,
  } = useListPhaseOrderScanStatus({
    params: {
      columnFilter: {
        // "filter[record_status]": "O",
      },
      page: -1,
    },
  });

  const {
    refetch: fetchListPhaseOrderScanActionType,
    data: listPhaseOrderScanActionType,
  } = useListPhaseOrderScanActionType({
    params: {
      columnFilter: {
        // "filter[record_status]": "O",
      },
      page: -1,
    },
  });

  useEffect(() => {
    if (phaseOrderScanParams && phaseOrderScanParams.run) {
      refetchListPhaseOrderScan();
    }
  }, [phaseOrderScanParams]);

  const [userProfileParams, setUserProfileParams] = useState({
    sizePerPage: 10,
    page: -1,
    sort: "-maker_date",
    columnFilter: {
      "filter[user_type][in]": [1, 4],
      "filter[record_status]": "O",
    },
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
    run: false,
  });

  const { data: userProfileList, refetch: listUserProfile } =
    useListUserProfile({ params: userProfileParams });

  const { data: myHubs, refetch: refetchMyHubs } = useMyHubsList();

  useEffect(() => {
    if (userProfileParams && userProfileParams.run) {
      listUserProfile();
    }
  }, [userProfileParams]);

  useEffect(() => {
    refetchMyHubs();
  }, []);

  useEffect(() => {
    if (myHubs) {
      if (isHubAdmin) {
        setPhaseOrderScanParams(prev => ({
          ...prev,
          columnFilter: {
            "filter[hub_id]": myHubs.hub.id,
          },
          run: true,
        }));
        setUserProfileParams(prev => ({
          ...prev,
          columnFilter: {
            ...prev.columnFilter,
            "filter[user_type][in]": [4],
            hub_id: myHubs.hub.id,
          },
          run: true,
        }));
      } else {
        const listChildHub =
          myHubs.childs_hub && myHubs.childs_hub.length > 0
            ? myHubs.childs_hub.flatMap(item => item.id)
            : [];
        const listHubCenter = [myHubs.hub.id, ...listChildHub];
        setPhaseOrderScanParams(prev => ({
          ...prev,
          columnFilter: {
            "filter[hub_id][in]": listHubCenter,
          },
          run: true,
        }));
        setUserProfileParams(prev => ({
          ...prev,
          columnFilter: {
            ...prev.columnFilter,
            "filter[user_type][in]": [1, 4],
            hub_id: listHubCenter.join(","),
          },
          run: true,
        }));
      }
    }

    fetchListPhaseOrderScanStatus();
    fetchListPhaseOrderScanActionType();
    initColumn();
  }, [t, isHubAdmin, myHubs]);

  const optionUserScan = useMemo(() => {
    if (userProfileList) {
      return userProfileList.items
        .filter(item => item.code)
        .map(item => {
          return {
            label: item.display_name,
            value: item.code,
          };
        });
    }
    return [];
  }, [userProfileList]);

  useEffect(() => {
    initColumn();
  }, [
    listPhaseOrderScan,
    userProfileList,
    listPhaseOrderScanStatus,
    listPhaseOrderScanActionType,
  ]);

  // useEffect(() => {
  //   if (allowFocusInputTrackingKey) {
  //     inputSearchTrackingKey.current.focus();
  //   }
  // }, []);

  // useEffect(() => {
  //   let intervalId = null;
  //   if (allowFocusInputTrackingKey) {
  //     intervalId = setInterval(() => {
  //       inputSearchTrackingKey.current.focus();
  //     }, 500);
  //   } else {
  //     clearInterval(intervalId);
  //   }
  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, [allowFocusInputTrackingKey]);
  /* ===================================== END HOOKS ======================================== */

  /* ================================ START FUNCTION HANDLER ================================ */

  const initColumn = () => {
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    dispatch(setListBusColumn(field, value));
    initColumn();
  };

  const selectOptionsTable = (cell = undefined, name = "", prefix = "") => {
    let options = [];
    const select = {};
    switch (name) {
      case "status":
        options = statusOption;
        break;
      default:
        if (cell) {
          return "";
        } else {
          return select;
        }
    }

    options.forEach(item => {
      select[item.key] = t(`table.${name}.${prefix}.${item.key}`);
    });

    if (cell) {
      return select[cell];
    }

    return { ...select };
  };

  const formatOptionsTable = (cell, name = "", label) => {
    let options = [];
    switch (name) {
      case "status":
        options = statusOption;
        break;
      default:
        return "";
    }

    return options.map(
      item =>
        item.key === cell && (
          <BadgeForTable
            key={item.key}
            badgeColor={item.badgeColor ? item.badgeColor : ""}
          >
            {label ? label : selectOptionsTable(cell, name)}
          </BadgeForTable>
        )
    );
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    setPhaseOrderScanParams(prev => {
      const columnFilterClone = filteredObject(prev.columnFilter, [
        "filter[start_id]",
        "filter[start_date]",
      ]);

      const startDateFilter = modifiedDateTime(
        columnFilter,
        "filter[start_date]"
      );
      const endDateFilter = modifiedDateTime(columnFilter, "filter[end_date]");

      return {
        ...prev,
        sort: sortField ? sortOrder + sortField : phaseOrderScanParams.sort,
        columnFilter: {
          ...columnFilterClone,
          ...columnFilter,
          ...startDateFilter,
          ...endDateFilter,
        },
        page: page || 1,
        sizePerPage: sizePerPage || 10,
      };
    });
  };

  const onSearchAllHandle = value => {
    setPhaseOrderScanParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const clickToScan = (row, index) => {
    switch (row?.action_type) {
      case "scan_receive":
        if (row.allowed_group_to_transfer) {
          navigate({
            pathname: `/scan-barcode?startScanId=${row.id}&transfer=1&from=${row.from_hub}&to=${row.to_hub}`,
          });
        } else {
          navigate({
            pathname: `/scan-barcode?startScanId=${row.id}&transfer=0`,
          });
        }

        break;
      case "scan_send":
        if (row.allowed_group_to_transfer) {
          navigate({
            pathname: `/scan-send-barcode?startScanId=${row.id}&transfer=1&from=${row.from_hub}&to=${row.to_hub}`,
          });
        } else {
          navigate({
            pathname: `/scan-send-barcode?startScanId=${row.id}&transfer=0`,
          });
        }
        break;

      default:
        break;
    }
  };

  const clickDetaillHandle = (row, index) => {
    window.open(
      `/phase-scan-barcode/${row?.id}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {},
  };

  /* ================================ END FUNCTION HANDLER ================================= */

  const listRowAction = [
    {
      icon: <i className="bx bxs-barcode text-success font-size-18" />,
      text: "Quét kiện với đợt hiện tại",
      onClick: clickToScan,
      conditionVisible: {
        status: [2], // Đang xử lý
      },
    },
    {
      icon: <i className="fas fa-eye fa-lg text-primary" />,
      text: "Chi tiết đợt quét kiện",
      onClick: clickDetaillHandle,
    },
  ];

  const listMultipleRowAction = [];

  const initColumns = [
    {
      dataField: "name",
      text: "Tên",
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: "Tên",
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "status",
      text: "Trạng thái quét kiện",
      sort: true,
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: "Trạng thái quét kiện",
        }),
        options: listPhaseOrderScanStatus || [],
      }),
      formatter: (cell, row) => {
        // "some" return boolean
        if (cell) {
          return formatOptionsTable(
            cell,
            "status",
            listPhaseOrderScanStatus?.[cell]
          );
        } else {
          return ""; // Set Empty If Value Not Match
        }
      },
      allowExport: true,
    },
    {
      dataField: "action_type",
      text: "Loại quét kiện",
      sort: true,
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: "Loại quét kiện",
        }),
        options: listPhaseOrderScanActionType || [],
      }),
      formatter: (cell, row) => {
        return listPhaseOrderScanActionType?.[cell];
      },
      allowExport: true,
    },
    {
      dataField: "total",
      text: "Tổng kiện đã quét",
      sort: true,
      formatter: (cell, row) => {
        return (
          <div
            style={{ fontWeight: "bold" }}
            className={`font-size-14 ${
              cell > 0 ? "text-primary" : "text-danger"
            }`}
          >
            {cell > 0 ? cell : "Chưa có"}
          </div>
        );
      },
    },
    {
      dataField: "start_date",
      text: "Thời gian bắt đầu",
      sort: true,
      formatter: (cell, row) => {
        let date = null;
        if (cell) {
          date = new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          date = "";
        }
        return (
          <div>
            <div className="">{date}</div>
          </div>
        );
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={phaseOrderScanParams.columnFilter}
          isHaveEqual={false}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "start_id",
      text: "Người bắt đầu quét",
      formatter: (cell, row) => {
        return (
          <div>
            <div className="text-primary">{row?.starter?.display_name}</div>
          </div>
        );
      },
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomSelectFilter
          onFilter={onFilter}
          column={column}
          paramFilter={phaseOrderScanParams.columnFilter}
          dataSelect={optionUserScan}
          placeholder={t("placeholder.select")}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "end_date",
      text: "Thời gian kết thúc",
      sort: true,
      formatter: (cell, row) => {
        let date = null;
        if (cell) {
          date = new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          date = "";
        }
        return <div>{date}</div>;
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={phaseOrderScanParams.columnFilter}
          isHaveEqual={false}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "end_id",
      text: "Người kết thúc quét",
      formatter: (cell, row) => {
        return (
          <div>
            <div className="text-info">{row?.finisher?.display_name}</div>
          </div>
        );
      },
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomSelectFilter
          onFilter={onFilter}
          column={column}
          paramFilter={phaseOrderScanParams.columnFilter}
          dataSelect={optionUserScan}
          placeholder={t("placeholder.select")}
        />
      ),
    },
  ];

  const handleKeyDown = event => {
    if (
      event.key.toLowerCase() === "enter" &&
      inputSearchTrackingKey.current.value
    ) {
      setPhaseOrderScanParams({
        ...phaseOrderScanParams,
        tracking_key: inputSearchTrackingKey.current.value,
      });
      inputSearchTrackingKey.current.value = "";
      inputSearchTrackingKey.current.focus();
      // Enter key is pressed
      // Perform your desired action here
      // toggleModal();
    }
  };

  const InputSearchTrackingKey = (
    <div className="d-flex align-items-center gap-2">
      <div className="search-box mb-md-2 me-2 d-inline-block flex-grow-1">
        <div className="position-relative" style={{ width: "305px" }}>
          <input
            // disabled={
            //   // isLoadingScanReceivce || isLoadingScanInfo
            // }
            style={{ width: "100%" }}
            ref={inputSearchTrackingKey}
            // value={searchTerm}
            type="search"
            onKeyDown={handleKeyDown}
            disabled={isLoading || isFetching}
            className="form-control"
            placeholder="Tìm kiếm kiểm kiện. (Enter để kiểm tra)"
          />
          <i
            className="bx bxs-barcode search-icon"
            style={{ color: "#50a5f1" }}
          />
          {phaseOrderScanParams.tracking_key && (
            <div
              className="d-flex gap-1 fw-bold font-size-14"
              style={{
                position: "absolute",
                top: "7px",
                right: "-147px",
              }}
            >
              ( Tracking key:{" "}
              <div className="text-info" style={{ fontStyle: "italic" }}>
                {phaseOrderScanParams.tracking_key}
              </div>
              )
              <i
                onClick={() => {
                  setPhaseOrderScanParams({
                    ...phaseOrderScanParams,
                    tracking_key: undefined,
                  });
                }}
                className="mdi mdi-close-thick text-danger font-size-15"
                style={{ cursor: "pointer" }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{"Đợt quét kiện"}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={
              "Đợt quét kiện" + ` (${listPhaseOrderScan?.totalCount || 0})`
            }
            breadcrumbItems={[
              { name: "Quản lý quét kiện" },
              { name: "Đợt quét kiện" },
            ]}
          />

          <Row>
            {/* Modal START*/}
            <Col className="col-12"></Col>
            {/* Modal E N D*/}
            <Col
              className="col-12"
              onFocus={() => {
                setAllowFocusInputTrackingKey(false);
              }}
            >
              <Card>
                <CardBody>
                  <RemoteDataTable
                    // selectRow={selectRowCheckbox}
                    keyField="id"
                    data={listPhaseOrderScan?.items || []}
                    columns={columnsTable}
                    page={phaseOrderScanParams.page}
                    sizePerPage={phaseOrderScanParams.sizePerPage}
                    totalSize={listPhaseOrderScan?.totalCount || 0}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    optionShowColumnHandel={optionShowColumnHandler}
                    rowEvents={rowEventsHandler}
                    listMultipleRowAction={listMultipleRowAction}
                    listRowAction={listRowAction}
                    loading={isLoading}
                    // customSearchComponent={InputSearchTrackingKey}
                  ></RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PhaseScanTheRow;
